import CreateNewAttorney from 'components/attorney';

export const NewAttorney = () => {
  return <CreateNewAttorney />;
};
